import { render, staticRenderFns } from "./ModalInformacionGrupo.vue?vue&type=template&id=9c26d73c&scoped=true"
import script from "./ModalInformacionGrupo.vue?vue&type=script&lang=js"
export * from "./ModalInformacionGrupo.vue?vue&type=script&lang=js"
import style0 from "./ModalInformacionGrupo.vue?vue&type=style&index=0&id=9c26d73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c26d73c",
  null
  
)

export default component.exports